import React, { useState, useEffect } from 'react'
import { Typography, Paper, Divider, Box, Button, Switch, Alert } from '@mui/material'
import Grid from '@mui/material/Grid2'
import 'dayjs/locale/es'
import { Editor } from '@tinymce/tinymce-react'
import { SearchService } from '../../services/SearchService'
import AddIcon from '@mui/icons-material/Add'

import DemandasTable from '../DemandasTable'
import { useSelector, useDispatch } from 'react-redux'
import { setCustomer, setInterview, setTab } from '../../Redux/TabDucks'
import { InterviewService } from '../../services/interviewService'
import { set } from 'react-hook-form'
import Swal from 'sweetalert2';


// VENTANA DE LA HOJA DE ATENCION
const InterviewForm = () => {
    const dispatch = useDispatch();
    const customer = useSelector((store) => store.tab.customer);
    const interview = useSelector((store) => store.tab.interview);
    const _TAB = useSelector((store) => store.tab);
    const general = useSelector((store) => store.general)

    const [finiquitado, setFiniquitado] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [bloquearAcciones, setBloquearAcciones] = useState(false);


    useEffect(() => {
        if (_TAB.contractFull?.cancel == true || _TAB.interview?.interview2?.cancel==true) {
            setCancelado(true)
            setBloquearAcciones(true)
        }
        
        if (_TAB.contractFull?.finiquitado == true) {
            setFiniquitado(true)
            setBloquearAcciones(true)
        }
        /*if (customerData && customerData.properties && customerData.properties.rut) {
            const rut = customerData.properties.rut;
            fetchPoderJudicial(rut);
        }*/
    }, [_TAB])

    //useEffect(() => {
    //    if (interview?.cancel)
    //        setCancelado(interview.cancel ?? false)
    //}, [_TAB])

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [causas, setCausas] = useState([]);
    const [content, setContent] = useState('');
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
    const [selectedCase, setSelectedCase] = useState(null);
    const [origenEntrevista, setOrigenEntrevista] = useState('remoto');

    const customerData = customer || {};
    //const rut = customerData?.properties.rut || "";

    useEffect(() => {
        if (customerData && customerData.properties && customerData.properties.rut && (!_TAB.customerFormatted || (Object.keys(_TAB.customerFormatted).length === 0 && _TAB.customerFormatted.constructor === Object))) {
            const rut = customerData.properties.rut;
            fetchPoderJudicial(rut);
        }
    }, [customerData]);

    useEffect(() => {
        if (_TAB.customerFormatted && _TAB.customerFormatted.rut && (!customerData || (Object.keys(customerData).length === 0 && customerData.constructor === Object))) {
            fetchPoderJudicial(_TAB.customerFormatted.rut);
        }
    }, [_TAB.customerFormatted]);

    useEffect(() => {
        setContent(interview.content);
        setOrigenEntrevista(interview.origen);
    }, [interview]);


    const fetchPoderJudicial = async (rut) => {
        try {
            const data = await SearchService.BusquedaCuasaPdj(rut);

            // cruce causas con tribunales
            /*const filteredTrib = general.tribunalesext.filter(t => t.codigoTribunalCivil !== null)

            const mappedData = data.map(element => {
                const tribunalMatch = filteredTrib.find(
                    t => t.codigoTribunalCivil.toString() === element.codTribunal
                );
                return {
                    ...element,
                    codTribunal: tribunalMatch ? tribunalMatch.id.toString() : element.codTribunal
                };
            });*/

            setCausas(data);
            setLoading(false);

        } catch {
            setError('Error al cargar las Causas');
            setLoading(false);
        }
    }

    // Función para normalizar strings: quita caracteres raros y pasa a minúsculas
    const normalizeString = (str) => {
        const response = (str || "")
            .toLowerCase()
            .replace(/[^\w\s]/gi, '') // quita caracteres no alfanuméricos excepto espacios
            .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // quita acentos

        return response;
    };

    const handleViewDetail = (causa) => {
        setSelectedCase(causa);
        setIsDetailModalOpen(true);
    };

    const handleViewRegister = () => {
        setSelectedCase(null);
        setIsRegisterModalOpen(true);
    };
    const handleCerrarDetail = () => {
        setIsDetailModalOpen(false);
    }
    const handleCerrarRegister = () => {
        setIsRegisterModalOpen(false);
    }

    const handleEditorChange = (content) => {
        setContent(content);
    };

    const agregarCausa = (nuevaCausa) => {
        setCausas(prev => [...prev, nuevaCausa]);
    }

    const handleOrigenEntrevista = (event) => {
        const origen = event.target.checked ? 'presencial' : 'remoto'
        setOrigenEntrevista(origen)
    }

    const submitInterview = async (event) => {
        if (!content) {
            const { isDismissed } = await Swal.fire({
                title: 'Se esta guardando la hoja de atención esta vacia, desea continuar?',
                showCancelButton: true,
            });
            if (isDismissed) return;
        }

        if(interview.content && interview.content!=content){
            const { isDismissedB } = await Swal.fire({
                title: 'Ha modificado la hoja de atención, desea continuar?',
                showCancelButton: true,
            });
            if (isDismissedB) return;
        }
        await InterviewService.UpdateHojaAtencion({ hojaAtencion: content, id: interview.id, origen: origenEntrevista, atendidoPor: interview.atendidoPor })
        dispatch(setInterview({ content, origen: origenEntrevista }))
        dispatch(setTab("1"))
    }

    return (
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
            <Alert severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>

            <Alert severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">Origen de la Entrevista</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{ mr: 2 }}>Remoto</Typography>
                        <Switch
                            disabled={bloquearAcciones}
                            checked={origenEntrevista === 'presencial'}
                            onChange={handleOrigenEntrevista}
                            name="origenEntrevista"
                            inputProps={{ 'aria-label': 'Origen de la Entrevista' }}
                        />
                        <Typography variant="body1" sx={{ ml: 2 }}>Presencial</Typography>
                    </Box>
                </Grid>
            </Grid>
            <DemandasTable
                causas={causas}
                loading={loading}
                customStyles={customStyles}
                isDetailModalOpen={isDetailModalOpen}
                isRegisterModalOpen={isRegisterModalOpen}
                selectedCase={selectedCase}
                handleViewRegister={handleViewRegister}
                handleCerrarRegister={handleCerrarRegister}
                handleViewDetail={handleViewDetail}
                handleCerrarDetail={handleCerrarDetail}
                customerData={customerData}
                agregarCausa={agregarCausa}
                bloquearAcciones={bloquearAcciones}
            />

            <Divider sx={{ mt: 3, mb: 3 }}>HOJA ENTREVISTA</Divider>
            <Editor
                apiKey="no89skh86yibdbm71do29mqz4ldjyv6h6ix52vctyv798ztf"
                value={content}
                onEditorChange={handleEditorChange}
                init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                }}
            />
            <Grid item xs={12} >
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                        disabled={bloquearAcciones}
                        variant="contained"
                        startIcon={<AddIcon />}
                        size="large"
                        onClick={submitInterview}
                    >
                        Guardar y Continuar
                    </Button>
                </Box>

            </Grid>

        </Paper>
    );
};
const customStyles = {
    table: {
        style: {
            minWidth: '100%',

        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            color: '#1D1D1F',
        },
    },
};
export default InterviewForm;